import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>First Line Manager & Manager of AI at Watson AR at IBM Financing<span>2023-present</span></h2>
                        <p>On July 2023, I've been chosen as the new First Line Manager of Watson AR Project in IBM Financing due to stellar contributions in cognitive systems deliveries, strategic planning, resourcefulness and responsibility. Under my leadership the project grew even more its portfolio of AI solutions for finance, spreading our collaboration not only to Accounts Receivables, but, also Treasury and Commercial Financing. I've led more than 15 employees for a period, and nowadays 10 employees dedicated to researching and developing cognitive solutions and hyperautomations in benefit of our organization collection processes, free cash flow prediction, as well as data governance.</p>
                      </div>
                    </div>
                </article>
                <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Lead Data Scientist at Watson AR at IBM Financing<span>2021-present</span></h2>
                        <p>On December 2021, I've been leading the data science efforts thanks to my contributions to our business within the areas of DS, ML, AI, and Cloud Computing.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Data Scientist at IBM Global Financing<span>2020-2023</span></h2>
                        <p>On December 2019, I've been pointed to assume the leading role of Data Scientist at IBM Global Financing, the first official at our financing domain at IBM at the time.</p>
                        <p>My goals are to lead the team of developers to research and develop machine learning models capable of optimize the accounts and receivables processes of IGF, and pave the environment to the new data science project to come to our business unit.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Doctor of Sciences in Informatics at Federal University of the State of Rio de Janeiro - UNIRIO<span>2020-2024</span></h2>
                        <p>I've continued my Master's research, improving and generalizing our proposed model and methodology, thus stablishing Sentiment Gradient as an efficient and generelizeable in three domains (news classification, product review, and electoral opinion classification). Bringing in average 5% increase in performance (F-Measure) to the application domains.</p>
                        <p>Advised by Ana Cristina Bicharra Garcia.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Iteration Manager(Scrum Master) at IBM Global Financing<span>2018-2021</span></h2>
                        <p>Due to my known sense of responsibility, technical knowledge, and innate leadership, or at least what my manager said to me at time, I've been chosen to be the Iteration Manager of our agile squad.</p>
                        <p>My mission as an Iteration Manager is to assume the Scrum Master's responsibilities, and also, part of the manager role (from IBM's view) such as people's management, knowledge management, and career advising.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Master of Sciences in Informatics at Federal University of the State of Rio de Janeiro - UNIRIO<span>2018-2019</span></h2>
                        <p>My M.Sc. in Informatics was advised by Ana Cristina Bicharra Garcia, together we researched and studied classification of Fake News. We proposed a new methodology and model capable of differentiate Brazilian Portuguese True, Sarcastic and Fake news.</p>
                        <p>Our works in the area are well known and cited by more than 10 others researches in this so recent area.</p>
                        <p>This research gave birth to three main papers, two surveys and an experiment.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Software Developer at IBM Global Financing<span>2017-2018</span></h2>
                        <p>Developing a cognitive application to optimize the AR processes of IGF's collectors' team.</p>
                        <p>After two years of internship at IBM, I've been hired to the position of Software Developer due to my knowledge, good and continuous work, and recommendations from my mentors.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Software Engineering Internship at IBM Research<span>2016-2017</span></h2>
                        <p>Due to my interest in the research area I've been chosen to be an intern at IBM Research.</p>
                        <p>I've worked at the Visual Analytics and Insights team, developing and researching about chatbots, web applications, and machine learning for Oil & Gas applications.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Software Development Internship at IBM Chief Information Office - CIO<span>2015-2016</span></h2>
                        <p>I've worked with conventional and non-convetional database management, and human and material resources management systems' development.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Bachelor in Information Systems at Federal University of the State of Rio de Janeiro - UNIRIO<span>2014-2017</span></h2>
                        <p>My graduation was in one of the best federal universities in the Brazil, UNIRIO.</p>
                        <p>The department of application informatics(DIA) is well known for partnership with BPM projects, Networks and Communication research groups around the world, and nowadays increasingly growing in AI research field.</p>
                        <p>My graduation thesis, advised by Kate Revoredo and Flávia Santoro, was about predictive monitoring of business processes. I've combined the sentiment analysis data from socio-political context data of processes' centers with their event logs data, and analyzed the process' flow.</p>
                        <p>The thesis was indeed consistent and interesting, giving continuity to an international paper which turned into a chapter in a conference journal.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
